// Debug logging state management using sessionStorage
// When enabled, adds X-Viam-Debug header to all gRPC and HTTP requests
const DEBUG_KEY = 'viam_debug_enabled';

export const enableDebugLogging = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(DEBUG_KEY, 'true');
  }
};

export const disableDebugLogging = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(DEBUG_KEY);
  }
};

export const isDebugLoggingEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(DEBUG_KEY) === 'true';
};
